import { RBIBrand, RBIEnv, RBIPlatform } from './types';

export const brand = () => process.env.REACT_APP_RBI_BRAND as RBIBrand;
export const env = () => (process.env.REACT_APP_RBI_ENV || RBIEnv.DEV) as RBIEnv;
export const platform = () => process.env.REACT_APP_RBI_PLATFORM as RBIPlatform;
export const checkPlatform = (is: RBIPlatform) => is === platform();
export const checkRbiEnv = (is: RBIEnv) => is === env();
export const appVersionCode = () => process.env.CIRCLE_SHA1 || process.env.COMMIT_REF || 'dev';

export const isLocalDev = process.env.NODE_ENV !== 'production';
export const isStoryBook = process.env.STORYBOOK === 'true';
export const isTest = process.env.NODE_ENV === 'test';
export const isProduction = checkRbiEnv(RBIEnv.PROD);
export const isWeb = checkPlatform(RBIPlatform.WEB);
export const isNative = checkPlatform(RBIPlatform.APP);
export const isMobile = () => /Mobile/.test(navigator.userAgent);
export const isNativeIOS = () => isNative && /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isIOS = () => {
  return (
    new Set(['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod']).has(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export const versionIsGreaterThanOrEqualTo = ({
  versionString,
  majorVersionGreaterThanOrEqualTo,
}: {
  versionString: string | null;
  majorVersionGreaterThanOrEqualTo: number;
}): boolean => {
  if (!versionString) {
    return false;
  }
  const majorVersion = Number(versionString.split('.')[0]);
  return majorVersion >= majorVersionGreaterThanOrEqualTo;
};
